import {useCompanyTariffGuard} from '../../../../modules/company-tariff';
import {FC, useContext, useRef} from 'react';
import {SubmitHandler, useForm} from 'react-hook-form';
import {toast} from 'react-toastify';
import {useSetRecoilState} from 'recoil';

import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import {Button, Stack, Typography} from '@mui/material';

import {EventBusContext} from '../../../../providers/EventBus';

import {deviceModelsQueryTrigger} from '../../../../store/deviceModels/atoms';

import {DictionaryService} from '../../../../api/services/dictionary.service';
import {IDeviceModel} from '../../../../shared/types/deviceModels.types';
import {IDeviceTypesDict} from '../../../../shared/types/deviceTypesDict.types';
import {DeviceModelFields} from './DeviceModelFields';

interface IAddDeviceModel {
  deviceTypes: IDeviceTypesDict[];
  handleClose: () => void;
  loading: boolean;
  setLoading: (arg: boolean) => void;
}

export const AddDeviceModel: FC<IAddDeviceModel> = ({handleClose, loading, setLoading, deviceTypes}) => {
  const {checkTariff, tariffLoading} = useCompanyTariffGuard();
  const {control, handleSubmit} = useForm<Omit<IDeviceModel, 'id'>>({mode: 'onChange'});
  const triggerDeviceModelsQuery = useSetRecoilState(deviceModelsQueryTrigger);
  const ref = useRef<HTMLFormElement | null>(null);
  const {bus} = useContext(EventBusContext);

  const onSubmit: SubmitHandler<Omit<IDeviceModel, 'id'>> = async (data) => {
    try {
      setLoading(true);

      await DictionaryService.createDeviceModel({
        ...data,
        model: data.model.trim(),
      });

      toast.success('Модель добавлена', {
        containerId: 'default',
        autoClose: 2000,
        hideProgressBar: true,
        pauseOnHover: false,
        draggable: false,
      });

      triggerDeviceModelsQuery((v) => v + 1);

      setTimeout(() => {
        setLoading(false);
        handleClose();
      });
    } catch (err) {
      bus?.emit('error', [err]);
      setLoading(false);
    }
  };

  return (
    <form
      style={{height: '100%'}}
      ref={ref}
      onSubmit={(event) => {
        event.preventDefault();
        if (checkTariff()) void handleSubmit(onSubmit)(event);
      }}
    >
      <Stack sx={{height: '100%'}} direction="column" justifyContent="space-between">
        <Stack sx={{height: '100%'}} direction="column" spacing={2}>
          <Stack direction="row">
            <Typography variant="h5">Добавить модель устройства</Typography>
          </Stack>

          <DeviceModelFields loading={loading} deviceTypes={deviceTypes} control={control} />
        </Stack>

        <Stack direction="row" sx={{justifyContent: 'space-between', mt: 4}}>
          <LoadingButton
            onClick={() => {
              ref?.current?.requestSubmit();
            }}
            variant="outlined"
            color="success"
            disabled={tariffLoading}
            loading={loading}
          >
            Добавить
          </LoadingButton>
          <Button onClick={handleClose} variant="outlined" color="error" disabled={loading}>
            Отмена
          </Button>
        </Stack>
      </Stack>
    </form>
  );
};
